import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import * as zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    position: "absolute",
    right: "calc(50% - 100px)",
    background: theme.palette.events.blueSecondary,
    fontSize: 14,
    paddingLeft: 2,
    color: theme.palette.white,
    zIndex: zIndexes.broadcastTotalRequestsZIndex,
    height: "38px",
    "&:focus": {
      background: theme.palette.events.blueSecondary,
    },
    "& .MuiChip-deleteIcon": {
      margin: "0 0 0 -12px !important",
    },
  },
  avatar: {
    width: 18,
    height: 18,
    cursor: "pointer",
  },
  delete: {
    color: theme.palette.white,
    borderRadius: "50%",
    padding: 3,
    width: 17,
    height: 17,
    "&:hover": {
      color: theme.palette.white,
    },
  },
  clickable: {
    borderRadius: 12,
    color: "#fff",
    width: 53,
    height: 24,
    marginLeft: 6,
    padding: 0,
  },
  viewButton: {
    width: "92px",
    color: theme.palette.events.blueSecondary,
    height: "28px",
    marginLeft: "12px",
    borderRadius: "20px",
    background: " #FFFFFF",
    boxShadow: "4px 4px 4px 0px #0C38911A",

    "&:hover": {
      color: theme.palette.events.blue,
    },
  },
  pointer: {
    cursor: "pointer",
  },
}));
